<template>
  <div v-if="visible" class="container absence-view absence-calendar">
    <div v-if="this.employees.length > 0" class="month">
      <ul>
        <button @click="() => changeMonth(-1)" class="prev btn btn-change">&#10094;</button>
        <button @click="() => changeMonth(1)" class="next btn btn-change">&#10095;</button>
        <li>
          <span class="color-blue">{{ monthName }}</span> <span class="color-grey font-18">{{ year }}</span>
          <SelectEmployees class="select-employee" defaultEmployee="wszyscy" :showLabel="false"
                           :prefetchedEmployees="this.employees" @remote_user="changeUser">
          </SelectEmployees>
        </li>
      </ul>
    </div>
    <div class="rows-tables">
      <transition-group name="fade">
        <table v-show="weeks" v-for="week in weeks" :key="week.id" class="table table-border table-week-days">
          <thead class="thead-pink bg-all-days">
          <tr>
            <DayCalendar v-for="date in week.dates" :key="date.id"
                         @add="add" @remove="remove" :resetFlag="resetFlag"
                         :date="formatDateToString(date)"
                         :isAnotherMonth="date.month() !== week.month"
                         :disabled="date <= today || foreignUser"
                         :absence="hasAbsence(date)"></DayCalendar>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in week.rows" :key="row.id" class="absence-cards">
            <template v-for="absence in row.absences">
              <td v-if="absence.username" :key="absence.id" :colspan="absence.span">
                <div class="absence-card-box" v-if="absence.username"
                     :style="{'border-color': getBackgroundColor(absence.remote_user)}"
                >{{ absence.username }}
                </div>
              </td>
              <td v-else :key="absence.id" :colspan="absence.span">
              </td>
            </template>
          </tr>
          <tr v-if="week.dates.length && !week.rows.length" class="absence-cards">
            <td :colspan="5"></td>
          </tr>
          </tbody>
        </table>
      </transition-group>
    </div>
    <button id="confirm" type="button" class="btn btn-orange btn-default btn-xs btn-confirm"
            v-if="addedToMake.length + addedToRemove.length > 0" @click="confirmChanges">
      <span>Zatwierdź zmiany</span><span><i class="material-icons">done</i></span>
    </button>
    <Vacation ref="vacation" @refreshMyRequest="getMyVacation"
                    @refreshCalendar="getAbsences" :myVacationRequest="myVacationRequests"></Vacation>
  </div>
</template>

<script>
import {backend} from '../../backend.js';
import DayCalendar from './DayCalendar.vue';
import SelectEmployees from '../SelectEmployee.vue';
import Constants from '../../constants.js';
import Vacation from "./Vacation.vue";

const DATE_FORMAT = Constants.get('DATE_FORMAT_FOR_BACKEND');
const MIDNIGHT_SUFFIX = Constants.get('MIDNIGHT_SUFFIX_FOR_BACKEND');

export default {
  name: "AbsenceCalendar",
  components: {
    Vacation,
    DayCalendar,
    SelectEmployees,
  },
  data() {
    return {
      user: '',
      date: moment().startOf('month'),
      absences: [],
      weeks: [],
      employees: [],
      addedToMake: [],
      addedToRemove: [],
      resetFlag: true,
      visible: false,
      myVacationRequests: []
    };
  },
  created() {
    Promise.all([this.getEmployees(), this.getAbsences()])
        .then(() => this.visible = true);
  },
  computed: {
    loggedInUser: function () {
      return this.$store.getters['auth/remoteUser'];
    },
    today: function () {
      return moment();
    },
    year: function () {
      return this.date.year();
    },
    monthName: function () {
      return moment.localeData('pl').months()[this.date.month()];
    },
    startOfMonth: function () {
      return moment(this.date).startOf('month').startOf('week');
    },
    endOfMonth: function () {
      return moment(this.date).endOf('month').endOf('week');
    },
    foreignUser: function () {
      return !(this.loggedInUser === this.user || this.user === '');
    },
  },
  methods: {
    getMyVacation() {
      return backend.getMyVacation()
          .then((response) => {
            this.myVacationRequests = response.data;
          })
          .catch(() => {
            this.$vs.notify({text: "Nie udało się pobrać listy moich wniosków, color: 'danger'"});
          });
    },
    formatDateToString: function (date) {
      return date.format(DATE_FORMAT);
    },
    hasAbsence: function (date) {
      let absence = this.absences.find(el => el.user.id === this.loggedInUser &&
          moment(el.on_date).isSame(date, 'day'));
      return absence !== undefined;
    },
    getBackgroundColor(remote_user) {
      let employee = this.employees.find(el => el.remote_user === remote_user);
      return employee ? employee['color'] : "#ffffff";
    },
    getTextColor(remote_user) {
      let employee = this.employees.find(el => el.remote_user === remote_user);
      return (employee && employee['text_color_reversed']) ? "#ffffff" : "#000000";
    },
    changeMonth: function (diff) {
      this.date = moment(this.date).add(diff, 'month');
      this.resetFlag = !this.resetFlag;
      this.addedToRemove = [];
      this.addedToMake = [];
      this.getAbsences();
    },
    changeUser: function (remoteUser) {
      this.user = remoteUser;
      this.getAbsences();
    },
    getEmployees() {
      return backend.getEmployees()
          .then((response) => {
            this.employees = response.data;
          })
          .catch(() => {
            this.$vs.notify({text: "Nie udało się pobrać listy pracowników", color: 'danger'});
          });
    },
    getAbsences: function (refresh = true) {
      if (refresh) {
        this.absences = [];
        this.weeks = [];
      }

      let fromDate = this.startOfMonth.format(DATE_FORMAT);
      let toDate = this.endOfMonth.format(DATE_FORMAT);
      let params = this.user === '' // means user is 'wszyscy' or doesnt exist in RemoteUser
          ? {from_date: fromDate, to_date: toDate}
          : {from_date: fromDate, to_date: toDate, user: this.user};

      return backend.getAbsences(params)
          .then((response) => {
            this.absences = response.data;
            this.weeks = this.calculateWeeks();
          })
          .catch(() => {
            this.$vs.notify({text: "Nie udało się pobrać listy urlopów", color: 'danger'});
          });
    },
    add: function (data) {
      if (!this.foreignUser) {
        if (data.absence)
          this.addedToRemove.push(this.absences.find(el => el.user.id === this.loggedInUser &&
              moment(new Date(el.on_date)).format(DATE_FORMAT) === data.date));
        else
          this.addedToMake.push({
            user: this.remoteUser,
            from_hour: Constants.get('DEFAULT_REPORT_FROM_TIME_MINUTES'),
            to_hour: Constants.get('DEFAULT_REPORT_TO_TIME_MINUTES'),
            on_date: data.date + MIDNIGHT_SUFFIX
          });
      }
    },
    remove: function (data) {
      if (!this.foreignUser) {
        if (data.absence)
          this.addedToRemove.splice(this.addedToRemove.findIndex(el => el.user.id === this.loggedInUser &&
              moment(new Date(el.on_date)).format(DATE_FORMAT) === data.date), 1);
        else
          this.addedToMake.splice(this.addedToMake.findIndex(el =>
              el.on_date === data.date + MIDNIGHT_SUFFIX), 1);
      }
    },
    confirmChanges: function () {
      let makeAbsences = Promise.resolve();
      let removeAbsences = Promise.resolve();

      if (this.addedToMake.length > 0) {
        makeAbsences = backend.makeAbsences(this.addedToMake)
            .then(() => {
              this.addedToMake = [];
            })
            .catch(() => {
              this.$vs.notify({
                text: 'Nie udało się dodać urlopów.',
                color: 'danger'
              })
            });
      }
      if (this.addedToRemove.length > 0) {
        removeAbsences = backend.removeAbsences(this.addedToRemove.map(abs => abs.id))
            .then(() => {
              this.addedToRemove = [];
            })
            .catch(() => {
              this.$vs.notify({
                text: 'Nie udało się usunąć urlopów.',
                color: 'danger'
              });
            });
      }
      Promise.all([makeAbsences, removeAbsences])
          .then(() => {
            this.getAbsences(false);
          });

    },
    calculateWeeks: function () {
      const msInDay = 1000 * 60 * 60 * 24;

      let result = [];
      let date = this.date;
      let start = this.startOfMonth;
      let end = this.endOfMonth;
      let numberOfDays = Math.round((end - start + 1) / msInDay);

      let findAbsences = (day) =>
          this.absences.filter(el => Math.floor((moment(el.on_date) - start) / msInDay) === day);

      for (let week = 0; week < 6; week++) {
        result.push({
          id: week,
          month: moment(date).startOf('month').month(),
          dates: [],
          rows: [],
        });
      }
      for (let week = 0; week < Math.floor(numberOfDays / 7); week++) {
        let id = 0;
        let actPending = [];
        for (let day = week * 7; day < (week + 1) * 7; day++) {
          let current_date = moment(start).add(day, 'days');
          result[week].dates.push(current_date);
          let absences = findAbsences(day);

          // checking which pending absences cant be extended
          for (let i = 0; i < actPending.length; i++) {
            let pending = actPending[i];
            if (pending) {
              let absence = absences.find(el => el.user.id === pending.remote_user);
              // can be extended -> span++
              if (absence) {
                absence.used = true;
                pending.span++;
              }
              // can't be, add to row and set to null (waiting to be filled)
              else {
                result[week].rows[i].absences.push({
                  id: id++,
                  span: pending.span,
                  username: pending.username,
                  remote_user: pending.remote_user,
                });
                actPending[i] = null;
              }
            } else {
              result[week].rows[i].absences.push({id: id++, span: 1});
            }
          }

          // here i'm looking for absences that hasn't been used yet and assign them to a row
          let actRow = 0;
          for (let absence of absences) {
            if (!absence.used) {
              while (actRow < actPending.length && actPending[actRow])
                actRow++;
              // i have to add create new row, none is free
              if (actRow === actPending.length) {
                result[week].rows.push({id: actRow, absences: []});
                for (let i = 0; i < day - 7 * week; i++) {
                  result[week].rows[actRow].absences.push({id: id++, span: 1});
                }
                actPending.push({});
              }
              // add new pending absence
              actPending[actRow] = {
                span: 1,
                username: absence.user.login,
                remote_user: absence.user.id,
              };
            }
          }
        }
        // shouldn't be needed, just so absences on Sunday also show
        for (let i = 0; i < actPending.length; i++) {
          let pending = actPending[i];
          if (pending) {
            result[week].rows[i].absences.push({
              id: id++,
              span: pending.span,
              username: pending.username,
              remote_user: pending.remote_user,
            });
          } else {
            result[week].rows[i].absences.push({id: id++, span: 1});
          }
        }
      }
      return result;
    }
  },
}
</script>

<style>
.fade-enter-active {
  transition: opacity .5s;
}

.fade-enter /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.absence-view {
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 1600px;
}

.absence-view > div {
  display: inline-block;
}

.absence-calendar {
  min-width: 600px;
}

.select-employee {
  position: relative;
  width: 160px;
  margin: auto;
}

.select-employee input {
  text-align: center;
  font-size: 1rem
}

.absence-cards {
  list-style-type: none;
  line-height: 1.15em;
  margin: 0;
  padding: 0;
}

table .absence-cards td {
  vertical-align: middle;
  margin: 0;
  padding: 0;
  border: 0;
}

.btn-change {
  background-color: inherit;
}

.btn-change:hover {
  color: #2C2C2C !important;
  background-color: white;
}

.table-week-days {
  table-layout: fixed;
  text-align: center;
  border-collapse: collapse;
}

.table-week-days th {
  padding: 10px;
  line-height: 1em;
  vertical-align: middle !important;
}

.table-week-days td {
  padding: 2px;
}

.table-week-days .week-day {
  font-size: 85%;
  color: #a0a0a0;
}

.month {
  padding: 10px 25px;
  width: 100%;
  background: #fff;
  border: 1px solid #afafaf;
  border-bottom: none;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  text-align: center;
  color: #212529;
}

.month ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.month ul li {
  color: white;
  font-size: 24px;
  text-transform: uppercase;
  letter-spacing: 3px;
}

.month .prev {
  float: left;
  padding: 10px;
  margin-top: 13px;
  color: #212529;

  &:hover {
    color: #ff6200 !important;
  }
}

.month .next {
  float: right;
  padding: 10px;
  margin-top: 13px;
  color: #212529;

  &:hover {
    color: #ff6200 !important;
  }
}

.bg-all-days {
  background: #fffbf0;
}

.table-border th {
  border-left: 1px solid #afafaf !important;
  border-right: 1px solid #afafaf !important;
  border-collapse: collapse;
}

table.table-week-days tr td:first-child {
  border-left: 1px solid #afafaf
}

table.table-week-days tr td:last-child {
  border-right: 1px solid #afafaf
}

#confirm {
  position: fixed;
  bottom: 10px;
  right: 10px;
}

.rows-tables {
  border-bottom: 1px solid #afafaf;
}

th {
  border-color: #afafaf !important;
}

.absence-card-box {
  margin: 5px;
  padding: 2px;
  border: 1px solid;
  border-top: 3px solid;
  border-radius: 3px;
  text-align: left;
  color: #5f5f5f;
}

.btn-confirm span:first-child {
  display: inline-block;
  vertical-align: text-bottom;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// AbsenceCalendar.vue?df6d0058